import React, { useMemo } from 'react';
import DynamicsDetailPage from '../DynamicsDetailPage';
import { getApiV1Url } from '../config/api';
import axios from 'axios';
import { Certif } from '../CertificatesPage';

interface DynamicsOSPageProps {
    filteredCertif?: Certif[];
}

const DynamicsOSPage: React.FC<DynamicsOSPageProps> = ({ filteredCertif: propFilteredCertif }) => {
    const [certif, setCertif] = React.useState<Certif[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            setCertif(propFilteredCertif);
            setLoading(false);
        }
    }, [propFilteredCertif]);
    
    React.useEffect(() => {
        if (propFilteredCertif !== undefined) {
            return;
        }
        
        const fetchData = async () => {
            try {
                const access = localStorage.getItem('access');
                const response = await axios.get<Certif[]>(getApiV1Url('CERTIFICATES'), {
                    headers: { Authorization: `Bearer ${access}` },
                });
                setCertif(response.data);
            } catch (error) {
                console.error('Error fetching certificates:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const filteredCertif = propFilteredCertif !== undefined ? propFilteredCertif : certif;

    const nameToOsIdFsa = useMemo(() => {
        const map = new Map<string, string>();
        filteredCertif.forEach(item => {
            if (!item.os_id_fsa) return;
            const name = (item.os_name || '').toString().trim();
            const number = (item.os_number || '').toString().trim();
            const key = name && number ? `${name} (${number})` : (name || number);
            if (!key || map.has(key)) return;
            map.set(key, item.os_id_fsa);
        });
        return map;
    }, [filteredCertif]);

    const getDynamicsData = useMemo(() => {
        return () => {
            const osCounts = new Map<string, Map<string, number>>();
            filteredCertif.forEach(item => {
                if (!item.cert_reg_data) return;
                const year = String(item.cert_reg_data.substring(0, 4));
                if (!osCounts.has(year)) osCounts.set(year, new Map());
                const m = osCounts.get(year)!;
                const name = (item.os_name || '').toString().trim();
                const number = (item.os_number || '').toString().trim();
                const key = name && number ? `${name} (${number})` : (name || number);
                if (!key) return;
                m.set(key, (m.get(key) || 0) + 1);
            });
            const osNames = Array.from(new Set(Array.from(osCounts.values()).flatMap(m => Array.from(m.keys())))).sort();
            const years = Array.from(new Set(filteredCertif.map(i => i.cert_reg_data ? i.cert_reg_data.substring(0,4) : '').filter(Boolean))).sort();
            return { years, names: osNames, counts: osCounts };
        };
    }, [filteredCertif]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                Загрузка...
            </div>
        );
    }

    return (
        <>
            <DynamicsDetailPage
                getDynamicsData={getDynamicsData}
                title="Органы по сертификации - Динамика"
                chartTitle="Динамика сертификатов по органам сертификации"
                maps={{ nameToOsIdFsa }}
            />
        </>
    );
};

export const DynamicsOSAltCharts: React.FC = () => {
    return null;
};

export default DynamicsOSPage;

